//import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';

import { Injectable } from "@angular/core";
import { environment as _env } from "../../environments/environment";
import { HttpClient } from '@angular/common/http';

import { CanActivate, Router, ActivatedRouteSnapshot,
         RouterStateSnapshot } from '@angular/router';
import { resolve } from 'url';

//import { map } from 'rxjs/operators';
//import 'rxjs/add/observable/forkJoin';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
    isAuthenticated: boolean = false;
    username: string = "";
    menu: any;

    constructor(private http: HttpClient) {}

    public checkAuthentication() {
        this.isAuthenticated = false;
        this.username = "";

        return new Promise((resolve, reject) => {
            resolve(false); // disabled backend authentication!

            /*
            this.http.jsonp<AuthenticatedUser>(_env.base_rest_url + 'loaduser', 'callback')
                .subscribe( 
                    res => {
                        this.isAuthenticated = res['isAuthenticated'];
                        this.username = res['username'];
                        this.menu = res['menues'];

                        if(_env.debug) console.log('AUTH RES: '  + this.username);

                        resolve(true); },
                    error => {
                        console.log('AUTH error: '  + error);
                        resolve(false);
                    }
                  );

            */
        })
    }

    public isUserAuthenticated(): boolean {
        return this.isAuthenticated;
    }

    public getUsername(): string {
        return this.username;
    }

    public getMenu(): any {
        return this.menu;
    }

}

export class AuthenticatedUser {
    isAuthenticated: boolean;
    username: string;
    menu: any;
}


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
              private http: HttpClient) { }

  canActivate() {
        //console.log('DOING AUTH AGAIN!');

        let router = this.router;
        let http = this.http;

        return new Observable<boolean>(obs=> {
            // authentication disabled!
            router.navigate(['/welcome']);
            obs.next(false);

            /*
            let obs1 = this.http.jsonp<AuthenticatedUser>(_env.base_rest_url + 'checkuser', 'callback');

            obs1.subscribe({
                next(auth: AuthenticatedUser) {
                    //if(_env.debug) console.log('AUTH check: '  + auth.isAuthenticated);
                    if(!auth.isAuthenticated || auth.username === '') {
                        router.navigate(['/welcome']);
                        obs.next(false);
                    }
                    else {
                        obs.next(true);
                    }
                },
                error(msg) {
                    //if(_env.debug) console.log('AUTH error messaging: '  + msg);
                    router.navigate(['/welcome']);
                    obs.next(false);
                }
            });
            */
        });

  }

}


